import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";
import {
    EmployeeScheduledQualificationInterface,
    ScheduledQualificationInterface,
} from "../interfaces/ScheduledQualificationInterface";

export const scheduledQualificationApiSlice = createApi({
    reducerPath: "scheduledQualificationApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: ["ScheduledQualification"],
    endpoints: (builder) => ({
        getScheduledQualifications: builder.query<
            {
                data: ScheduledQualificationInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
                sort?: string;
                filter?: {
                    establishment_id?: number;
                    search?: string;
                };
            }
        >({
            query: (values) => ({
                url: `${ApiEnum.SCHEDULED_QUALIFICATION}?${createQueryString(values)}`,
                method: "GET",
            }),
            providesTags: ["ScheduledQualification"],
        }),
        getEmployeeScheduledQualifications: builder.query<
            {
                data: EmployeeScheduledQualificationInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
                sort?: string;
                filter?: {
                    establishment_id?: number;
                    search?: string;
                    employee_id?: number;
                };
            }
        >({
            query: (values) => ({
                url: `${ApiEnum.SCHEDULED_QUALIFICATION}/employees?${createQueryString(values)}`,
                method: "GET",
            }),
            providesTags: ["ScheduledQualification"],
        }),
        scheduleQualification: builder.mutation<
            { data: ScheduledQualificationInterface },
            {
                data: object;
            }
        >({
            query: (values) => ({
                url: ApiEnum.SCHEDULED_QUALIFICATION,
                method: "POST",
                body: values.data,
            }),
            invalidatesTags: ["ScheduledQualification"],
        }),
        editScheduledQualification: builder.mutation<
            { data: ScheduledQualificationInterface },
            {
                id: string;
                data: object;
            }
        >({
            query: (values) => ({
                url: `${ApiEnum.SCHEDULED_QUALIFICATION}/${values.id}`,
                method: "PATCH",
                body: values.data,
            }),
            invalidatesTags: ["ScheduledQualification"],
        }),
        deleteScheduledQualification: builder.mutation<
            { data: ScheduledQualificationInterface },
            {
                id: string;
            }
        >({
            query: (values) => ({
                url: `${ApiEnum.SCHEDULED_QUALIFICATION}/${values.id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ScheduledQualification"],
        }),
    }),
});

export default scheduledQualificationApiSlice.reducer;

export const {
    useGetScheduledQualificationsQuery,
    useGetEmployeeScheduledQualificationsQuery,
    useScheduleQualificationMutation,
    useEditScheduledQualificationMutation,
    useDeleteScheduledQualificationMutation,
} = scheduledQualificationApiSlice;
